import { isValidPhoneNumber } from 'libphonenumber-js';

export function isValidInternationalPhone(value) {
    return isValidPhoneNumber(String(value));
}
